export default __webpack_public_path__ + "static/media/testimonials@3x.8aa0af81.png";